import React, { useEffect } from "react";
import AuthPage from "./pages/AuthPage";

import HomePage from "./pages/HomePage";
import FriendsPage from "./pages/FriendsPage";
import ProfilePage from "./pages/ProfilePage";
import RatingPage from "./pages/RatingPage";
import PremiumPage from "./pages/PremiumPage";
//Footer pages
import About from "./pages/About";
import RefundPolicy from "./pages/RefundPolicy";
import PricingDetails from "./pages/PricingDetails";
import ContactUs from "./pages/ContactUs";
import NotFound from "./pages/NotFound";
import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
import TalkingPage from "./pages/TalkingPage";
import FriendRequestPage from "./pages/FriendRequestPage";
import { getMessaging, onMessage } from "firebase/messaging";
import FriendsTalkingPage from "./pages/FriendsTalkingPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import OtpPage from "./pages/OtpPage";
import ForgotPassPage from "./pages/ForgotPassPage";
import ReferralPage from "./pages/ReferralPage";
import TermsAndConditionsPage from "./pages/TermsAndConditionsPage";
import VideoHomePage from "./pages/VideoHomePage";
import VideoCallPage from "./pages/VideoCallPage";
import DeleteAccount from "./pages/DeleteAccount";
import DeleteAccountConfirmation from "./pages/DeleteAccountConfirmation";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Import default styling
//Psychologists Pages
import PsychologistSignupPage from "./pages/PsychologistSignupPage";
import PrivacyPolicyPsychologist from "./pages/PrivacyPolicyPsychologist";
import PsychologistAudioHome from "./pages/PsychologistAudio/PsychologistAudioHome";
import PsychologistAudioCall from "./pages/PsychologistAudio/PsychologistAudioCall";
import PsychologistVideoHome from "./pages/PsychologistVideo/PsychologistVideoHome";
import PsychologistVideoCall from "./pages/PsychologistVideo/PsychologistVideoCall";
import PsychologistHeader from "./components/PsychologistHeader";
import PsychologistHomevisit from "./pages/PsychologistHomevisit/PsychologistHomevisit";
import WccPlanBuy from "./pages/Plans/WccPlanBuy";
import GoodCallPlanBuy from "./pages/Plans/GoodCallPlanBuy";
import EmployeeCarePlanBuy from "./pages/Plans/EmployeecarePlanBuy";
import PodcastHome from "./pages/audio/PodcastHome";
import PodcastDetails from "./pages/audio/PodcastDetails";
import SleepHome from "./pages/audio/SleepHome";
import SleepDetails from "./pages/audio/SleepDetails";

function App() {
  useEffect(() => {
    const messaging = getMessaging();
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .then((registration) => {
          // console.log("Service Worker registered successfully:", registration);
        })
        .catch((err) => {
          console.error("Service Worker registration failed:", err);
        });
    }
    // Listen for notification clicks when the app is in the background
    navigator.serviceWorker.ready.then((registration) => {
      registration.addEventListener("notificationclick", (event) => {
        event.notification.close(); // Close the notification
      });
    });

    // (Optional) Handle foreground notifications
    onMessage(messaging, (payload) => {
      console.log("Foreground notification received: ", payload);
    });
  }, []);

  return (
    <>
      <ToastContainer />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/friends" element={<FriendsPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/login" element={<AuthPage />} />
        <Route path="/talk" element={<TalkingPage />} />
        <Route path="/rate" element={<RatingPage />} />
        <Route path="/prime" element={<PremiumPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/notFound" element={<NotFound />} />
        <Route path="/friendzone" element={<FriendRequestPage />} />
        <Route path="/friendchat" element={<FriendsTalkingPage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/otp" element={<OtpPage />} />
        <Route path="/forgotPass" element={<ForgotPassPage />} />
        <Route path="/refer" element={<ReferralPage />} />
        <Route path="/terms" element={<TermsAndConditionsPage />} />
        <Route path="/vision" element={<VideoHomePage />} />
        <Route path="/videocall" element={<VideoCallPage />} />
        <Route path="/signup" element={<PsychologistSignupPage />} />
        <Route path="/delete" element={<DeleteAccount />} />
        <Route path="/decide" element={<DeleteAccountConfirmation />} />
        <Route path="/policy" element={<PrivacyPolicyPsychologist />} />
        <Route path="/audio" element={<PsychologistAudioCall />} />
        <Route path="/audioroom" element={<PsychologistAudioHome />} />
        <Route path="/visual" element={<PsychologistVideoCall />} />
        <Route path="/videoroom" element={<PsychologistVideoHome />} />
        <Route path="/psyheader" element={<PsychologistHeader />} />
        <Route path="/homevisit" element={<PsychologistHomevisit />} />
        <Route path="/refund" element={<RefundPolicy />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/price" element={<PricingDetails />} />
        <Route path="/wccbuy" element={<WccPlanBuy />} />
        <Route path="/gcbuy" element={<GoodCallPlanBuy />} />
        <Route path="/ecare" element={<EmployeeCarePlanBuy />} />
        <Route path="/podcastroom" element={<PodcastHome />} />
        <Route path="/podcast" element={<PodcastDetails />} />
        <Route path="/sleeproom" element={<SleepHome />} />
        <Route path="/sleep" element={<SleepDetails />} />
      </Routes>
    </>
  );
}

export default App;
